/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../definitions/pagedown/pagedown.d.ts" />
/// <reference path="../definitions/select2/select2.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/storeManualEntry.ts" />
/// <reference path="../public/validationcomponent/validationComponent.ts" />

declare var irep: IREP.IREP;

namespace IREP {

    export interface IRetailerSearchOptions {
        id: string;
        isDre: boolean;
    }

    export class RetailerSearch extends ValidationComponentV3 {
        private options: IRetailerSearchOptions;
        private closeCallback: Function;
        private storeManual: StoreManualEntry;
        private scrollPosition: number;

        private searchForm: JQuery;
        private searchBackdrop: JQuery;
        private searchModal: JQuery;
        private searchText: JQuery;
        private closeForm: JQuery;
        private searchResults: JQuery;
        private selectedValue: JQuery;
        private buttonSelect: JQuery;
        private buttonCantFind: JQuery;
        private hiddenPromoterRetailerSearch: JQuery;
        private hiddenRetailerSearch: JQuery;
        private searchResultItems: JQuery;

        private countryCode: string;

        constructor(options: IRetailerSearchOptions) {
            super(options.id);
            this.options = options;

            this.searchForm = this.$component.find("#StoreSearchForm");
            this.searchBackdrop = this.$component.find("#SearchBackdrop");
            this.searchModal = this.$component.find("#SearchModal");
            this.closeForm = this.$component.find("#FormCloseButton");
            this.searchText = this.$component.find("#searchText");
            this.searchResults = this.$component.find("#searchResults");
            this.selectedValue = this.$component.find("#selectedValue");
            this.buttonSelect = this.$component.find("#buttonSelect");
            this.buttonCantFind = this.$component.find("#buttonCantFind");
            this.hiddenPromoterRetailerSearch = this.$component.find("#StorePositionModel_PromoterRetailerCountrySearch");
            this.hiddenRetailerSearch = this.$component.find("#StorePositionModel_RetailerCountrySearch");

            this.bindEvents();
        }

        private bindEvents() {
            this.unbindEvents();

            this.searchBackdrop.on("click", (e) => this.closeSearch());
            this.closeForm.on("click", (e) => this.closeSearch());
            this.searchModal.on("click", (e) => e.preventDefault());
            this.searchText.on("keyup", (e) => this.pauseSearchRetailers());
            this.searchResults.on("click", (e) => this.setSelection(e));
            this.searchResults.on("dblclick", (e) => this.takeSelection());
            this.buttonSelect.on("click", (e) => this.takeSelection());
            this.buttonCantFind.on("click", (e) => this.manualRetailer());
            this.hiddenPromoterRetailerSearch.on("change", (e) => this.changePromoterCountry());
            this.hiddenRetailerSearch.on("change", (e) => this.changeCountry());
            this.searchModal.on("click", (e) => e.stopPropagation()); //Prevent clickthrough on modal causing searchBackdrop.click to fire.

            this.searchRetailers();
            document.addEventListener('keypress', (e) => this.processKey2(e));
        }

        //Setting header texts for the search
        public setMode(mode: number) {
            if (mode == StorePosition.PositionMode.RETAILER) {
                $(".retailerText").removeClass("hidden");
                $(".manufacturerText").addClass("hidden");
                $(".promoterText").addClass("hidden");
            } else if (mode == StorePosition.PositionMode.MANUFACTURER) {
                $(".retailerText").addClass("hidden");
                $(".manufacturerText").removeClass("hidden");
                $(".promoterText").addClass("hidden");
            } else {
                $("#RetailerSearchContainer .retailerText").removeClass("hidden");
                $(".manufacturerText").addClass("hidden");
                $("#PromoterRetailerSearchContainer .promoterText").removeClass("hidden");
            }
        }

        public processKey2(e: KeyboardEvent) {
            if (e.keyCode == 13 || e.keyCode == 32) { //Enter or Space
                if (this.searchResults.attr('id') == $(e.target).attr('id')) {
                    //Take the option if you hit space or enter while it's targeted. 
                    this.takeSelection()
                    e.preventDefault();
                }
            }
        };

        private unbindEvents() {
            this.searchBackdrop.unbind('click');
            this.closeForm.unbind('click');
            this.searchModal.unbind('click');
            this.searchText.unbind('change');
        }

        public manualForm(value: StoreManualEntry) {
            this.storeManual = value;
        }

        //Set the function to be called when the form is closed. Functions receives the selected retailer ID and Name. 
        public setCallback(closeCallback: (id: number, name: string) => any) {
            this.closeCallback = closeCallback;
        }

        public openSearch() {
            this.searchForm.removeClass('hidden'); //Open Window

            //Resize search window to match the available size of the window.
            $("#SearchModal").height($(window).height());
            $("#searchResults").height($("#SearchModal").height() - $(".searchFields").outerHeight(true) - 100);

            this.searchRetailers(); //Populate list of retailers 

            //Before you open the modal, determine the current position on the screen. 
            //You need to do position: fixed on mobile, but that resets the screen position to zero, so we need to save the position. 
            //On desktop you're not able to scroll at all, so you're only scrolling to the current position. 
            this.scrollPosition = $("body").scrollTop();
            $("body").addClass("modal-open"); //Tell the form that the modal is open, to prevent scrolling.
        }

        private closeSearch() {
            this.searchForm.addClass('hidden');
            $("body").removeClass("modal-open"); //Allow scrolling again.
            $("body").scrollTop(this.scrollPosition); //Scroll back to the original position. 
        }

        public setCountry(countryCode: string, countryName: string) {
            this.hiddenRetailerSearch.val(countryCode).trigger('change');
        }

        public setPromoterCountry(countryCode: string, countryName: string) {
            this.hiddenPromoterRetailerSearch.val(countryCode).trigger('change');
        }

        private showCountryDropdown() {
            this.hiddenRetailerSearch.select2("open");
        }

        private showPromoterCountryDropdown() {
            this.hiddenPromoterRetailerSearch.select2("open");
        }

        private changeCountry() {
            this.countryCode = this.hiddenRetailerSearch.val();
            this.searchRetailers();
        }

        private changePromoterCountry() {
            this.countryCode = this.hiddenPromoterRetailerSearch.val();
            this.searchRetailers();
        }

        private setSelection(e: JQueryEventObject) {
            if (e.target.localName == "li") {
                $("li.selected").removeClass('selected'); //Clear previous selections
                $(e.target).addClass('selected'); //Select current item. 
                this.selectedValue.html($(e.target).html());
                this.searchResults.val($(e.target).attr('data-value'));
                this.buttonSelect.removeClass('hidden');
            }
        }

        private takeSelection() {
            if (this.searchResults.val() != null && this.searchResults.val() != "") {
                this.closeSearch();
                this.closeCallback(this.searchResults.val(), this.selectedValue.html());
            }
        }

        private manualRetailer() {
            this.closeSearch();
            this.storeManual.open(true);
        }

        private pauseSearchRetailers() {
            var qq = this;
            clearTimeout($(this).data('timeout'));
            $(this).data('timeout', setTimeout(function () {
                qq.searchRetailers();
            }, 500));
        }

        private searchRetailers() {
            var qq = this;

            $.ajax({
                type: "get",
                dataType: "json",
                url: irep.options.appUrl + "SearchRetailers",
                data: { CountryCode: this.countryCode, SearchText: this.searchText.val(), IsDre: this.options.isDre, Limit: 100 }
            }).done(function (d) {
                var listItems = "";

                for (var i = 0; i < d.Data.length; i++) {
                    listItems += "<li data-value='" + d.Data[i].Id + "'>" + d.Data[i].Name + "</li>";
                }
                qq.searchResults.html(listItems);
            });
        }
    }

}